var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-leak-list animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "b-card",
              [
                _c("div", { staticClass: "col-lg-12 leak-list-header" }, [
                  _c("span", { staticClass: "lbv-page-title" }, [
                    _vm._v("Removed Devices"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row secondary lbv-search" }, [
                  _c(
                    "form",
                    {
                      staticClass: "lbv-search-filter leak-list-form",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.search.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "leaklistFilters w-100" },
                        [
                          _c(
                            "b-row",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Search Type",
                                        "label-for": "search-type",
                                      },
                                    },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.searchType,
                                              expression: "searchType",
                                            },
                                          ],
                                          staticClass:
                                            "form-control full-width",
                                          attrs: {
                                            id: "search-type",
                                            accesskey: "/",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.searchType = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "last_name" } },
                                            [
                                              _vm._v(
                                                "\n                        Surname\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "first_name" } },
                                            [
                                              _vm._v(
                                                "\n                        First name\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "leakbot_id" } },
                                            [
                                              _vm._v(
                                                "\n                        LeakBot ID\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "device_name" } },
                                            [
                                              _vm._v(
                                                "\n                        SigFox ID\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Search",
                                        "label-for": "search",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.searchString,
                                            expression: "searchString",
                                          },
                                        ],
                                        staticClass: "form-control w-100",
                                        attrs: {
                                          id: "search",
                                          type: "text",
                                          required: "",
                                        },
                                        domProps: { value: _vm.searchString },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.searchString =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Tenant",
                                        "label-for": "select-tenants",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: { id: "select-tenants" },
                                          on: { input: _vm.fetchLeakListData },
                                          model: {
                                            value: _vm.tenantSelection,
                                            callback: function ($$v) {
                                              _vm.tenantSelection = $$v
                                            },
                                            expression: "tenantSelection",
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [
                                              _vm._v(
                                                "\n                        All Tenants\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.tenants,
                                            function (tenant) {
                                              return _c(
                                                "option",
                                                _vm._b(
                                                  {
                                                    key: tenant.id,
                                                    domProps: {
                                                      value: {
                                                        name: tenant.name,
                                                      },
                                                    },
                                                    on: {
                                                      option: function (
                                                        $event
                                                      ) {
                                                        return _vm.$emit(
                                                          "option",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "option",
                                                  _vm.$attrs,
                                                  false
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(tenant.name) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Rows",
                                        "label-for": "rows-filter",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "rows-filter",
                                          options: _vm.pageOptions,
                                        },
                                        on: { input: _vm.fetchLeakListData },
                                        model: {
                                          value: _vm.perPage,
                                          callback: function ($$v) {
                                            _vm.perPage = $$v
                                          },
                                          expression: "perPage",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex align-items-center",
                                  attrs: { cols: "3" },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "w-100 mr-3",
                                      attrs: {
                                        id: "applyBtn",
                                        variant: "primary",
                                        type: "submit",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Apply\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "w-100",
                                      attrs: {
                                        type: "submit",
                                        variant: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.downloadReport.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "download" }, [
                                        _vm._v("Export CSV File"),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-alert",
                  {
                    attrs: { show: _vm.errorMessage != "", variant: "danger" },
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.errorMessage) + "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    small: "",
                    responsive: "",
                    striped: "",
                    hover: "",
                    items: _vm.deviceList,
                    fields: _vm.fields,
                    "per-page": _vm.perPage,
                    "current-page": _vm.currentPage,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "leakbotId",
                      fn: function (data) {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "deviceLink",
                              attrs: {
                                to: {
                                  name: "DeviceView",
                                  params: { deviceID: data.value },
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.value) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "needHelp",
                      fn: function (data) {
                        return [
                          data.item.needHelp === "GetHelp"
                            ? _c("strong", [_vm._v(_vm._s(data.value))])
                            : _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(data.value) +
                                    "\n            "
                                ),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "repairComplete",
                      fn: function (data) {
                        return [
                          data.item.repairComplete === "GetHelp"
                            ? _c("strong", [_vm._v(_vm._s(data.value))])
                            : _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(data.value) +
                                    "\n            "
                                ),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page prev",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: _vm.pageNumber === 1,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Prev\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page next",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: !_vm.hasNextPage,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Next\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "current-page" }, [
                  _vm._v(
                    "\n          Page: " + _vm._s(_vm.pageNumber) + "\n        "
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }